export default __webpack_public_path__ + "3d6140cd9b54c480232a3f6c510745fd.png";